module.exports = __webpack_public_path__ + "static/media/AboutUs.9c1af3e6.jpg";